// @/services/alerts.js
const API_BASE = 'https://new.sbdemolition.online/api/alerts';

export const alertsAPI = {
  // جلب كل الـ alerts النشطة
  list: async () => {
    const res = await fetch(`${API_BASE}/list.php`, {
      credentials: 'include',
    });
    return res.json();
  },

  // إنشاء alert جديد ✅ محدث
  create: async (alertData) => {
    const res = await fetch(`${API_BASE}/create.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(alertData),
    });
    return res.json();
  },

  // إخفاء alert
  dismiss: async (alertId) => {
    const res = await fetch(`${API_BASE}/dismiss.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ alertId }),
    });
    return res.json();
  },
};
